import React from 'react';
import ReactDOM from 'react-dom/client';
import { LoaderProvider } from './context/LoaderContext';
import './assets/css/common.css';
import './assets/css/style.css';
import './assets/css/variables.css';
import './assets/css/customized.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import './utils/errorReporter';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LoaderProvider>
    <App />
    <ToastContainer />
  </LoaderProvider>,
);
